import React from 'react';

const SERVER_CHANGELOG = [
  { version: '2.4.27', message: 'Add KPIs page, custom graph builder, multi-series compare, and Inspect tab.' },
  { version: '2.4.22', message: 'Add survey results tab and targeted test survey deployments.' },
  { version: '2.4.17', message: 'Remove release force update flag' },
  { version: '2.4.16', message: 'Add search, filters, and pagination to beta users.' },
  { version: '2.4.15', message: 'Enforce beta tester cap and add portal capacity UI.' },
  { version: '2.4.14', message: 'Split task and question libraries and polish deploy-test cards.' },
  { version: '2.4.13', message: 'Add beta tester cap and landing-page spots banner.' },
  { version: '2.4.12', message: 'Add action-item table, results pies, and release test lock.' },
  { version: '2.4.11', message: 'Add deploy-test list filters and toolbar layout.' },
  { version: '2.4.10', message: 'Polish Linear action items and firmware version color.' },
  { version: '2.4.9', message: 'Add Linear action items on deploy tests.' },
  { version: '2.4.8', message: "Bind tester tests to each phone's hardware id." },
  { version: '2.4.7', message: 'Add test status by platform and show all official fleet models.' },
  { version: '2.4.6', message: 'Add test results overview and per-phone completion counts.' },
  { version: '2.3.29', message: 'Show none, opt-in, and force on the OTA Status chart.' },
  { version: '2.3.28', message: 'Replace OTA eligible flags with none, opt-in, and force modes.' },
  { version: '2.3.27', message: 'Split Overview into Financial, Work, Fleet, and Social widgets.' },
  { version: '2.3.26', message: 'Verify Sentry with the org slug so internal tokens can connect.' },
  { version: '2.3.25', message: 'Connect Google Ads through the Fluora client instead of the MCC.' },
];

const ServerChangelogView: React.FC = () => (
  <div className="container-fluid py-3">
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
      <div>
        <h2 className="mb-1">Server Changelog</h2>
        <p className="text-muted mb-0">Version bump history for the Fluora server.</p>
      </div>
    </div>

    <div className="card shadow-sm">
      <div className="list-group list-group-flush">
        {SERVER_CHANGELOG.map((entry) => (
          <div key={entry.version} className="list-group-item py-3">
            <div className="d-flex flex-wrap align-items-baseline gap-2">
              <span className="badge text-bg-dark">v{entry.version}</span>
              <span className="fw-semibold">{entry.message}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ServerChangelogView;
